import { useMemo, useState } from 'react';
import _ from 'underscore'
import { dateConvert } from '../../../utils/Helper';

export const usePerformanceGrid = ({ precisionReport, setPrecisionReport, rowData }) => {

    const [tooltip, setTooltip] = useState({});
    const tableRows = [
        { category_label: "Business Understanding", category_key: "bu_rank" },
        { category_label: "Database Efficiency", category_key: "db_eff_rank" },
        { category_label: "Technical Efficiency", category_key: "tech_rank" },
        { category_label: "Time Effort", category_key: "time_efficiency_rank" },
        { category_label: "Extra Efforts", category_key: "extra_efforts" },
    ];

    const getRatingStyle = (rating) => {
        let styles = { bg: "#ffffff", text: "#000000" };
        if (rating < 4.5) {
            styles = { bg: "#fee2e2", text: "#991b1b" };
        } else if (rating < 6.0) {
            styles = { bg: "#ffedd5b9", text: "#91471c" };
        } else if (rating < 7.5) {
            styles = { bg: "#fef3c7", text: "#78350f" };
        } else if (rating < 8.9) {
            styles = { bg: "#b6f2cb", text: "#0e5027" };
        } else if (rating <= 10) {
            styles = { bg: "#047857", text: "#ffff" };
        }
        return {
            backgroundColor: styles.bg,
            color: styles.text,
            textAlign: "center",
            fontWeight: "600",
        };
    };

    const columns = useMemo(() => {
        return [
            {
                key: "category_label",
                label: "Category / Leads",
                pinned: "left",
                style: { width: "180px", fontWeight: "bold" },
                render: (row) => <div className='py-3'>{row?.category_label}</div>
            },
            ...rowData?.map(lead => ({
                key: lead?.group_key,
                headerRender: () => {
                    const scores = [
                        lead?.bu_rank,
                        lead?.db_eff_rank,
                        lead?.tech_rank,
                        lead?.time_efficiency_rank,
                        lead?.extra_efforts
                    ];
                    const avg = (scores.reduce((a, b) => a + b, 0) / scores.length).toFixed(2);
                    let header = lead?.group_key?.includes("/")
                    if (header) {
                        header = lead.group_key?.split("/")
                        const date = `${header[0]}-01-${header[1]}`
                        header = dateConvert(date, "month-year")
                    } else {
                        header = lead?.group_key
                    }
                    return (
                        <div className='text-center py-1'>
                            <p className="mb-0">{header}</p>
                            <span className='text-primary'>({avg})</span>
                        </div>
                    );
                },
                headerStyle: { textAlign: "center" },
                style: { width: `100px`, padding: "0px", flex: 1 },
                render: (row) => {

                    const value = lead[row?.category_key];
                    return (
                        <div
                            className='p-3 px-0 c-pointer precision-summary'
                            onMouseOver={() => setTooltip(lead)}
                            style={getRatingStyle(parseFloat(value))}
                            onClick={() => setPrecisionReport({ show: true, group_key: lead?.manager_user_code ? lead?.manager_user_code : lead?.group_key, range: "" })}
                        >
                            {value}
                        </div>
                    );
                }
            }))
        ];
    }, [rowData]);


    return { columns, precisionReport, tooltip, tableRows }
}